"use client";

import { useEffect, useState } from "react";

/**
 * Affiche l'année courante côté visiteur.
 * `fallback` (l'année du build) est rendu au serveur et au premier rendu client
 * pour que l'HTML corresponde ; l'effet corrige ensuite si l'année a changé.
 */
export default function CurrentYear({ fallback }: { fallback: number }) {
  const [year, setYear] = useState(fallback);

  useEffect(() => {
    const current = new Date().getFullYear();
    if (current !== fallback) setYear(current);
  }, [fallback]);

  return <>{year}</>;
}
